/**
 * 认证相关 Hooks
 */
import { useAuthStore } from '@/store/authStore'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export const useAuth = () => {
  const { token, user, isAuthenticated, login, logout, updateUser, fetchCurrentUser } = useAuthStore()
  const navigate = useNavigate()

  useEffect(() => {
    // 只有当有 token 但没有 user 时才获取用户信息
    if (token && !user) {
      // console.log('[useAuth] Fetching current user...')
      fetchCurrentUser()
        .then(() => {
          // console.log('[useAuth] Current user fetched:', fetchedUser)
        })
        .catch((error) => {
          // 如果获取用户信息失败（如 401），清除无效的 token
          console.error('[useAuth] Failed to fetch current user:', error)
          logout()
        })
    }
  }, [token, user, fetchCurrentUser, logout])

  return {
    token,
    user,
    isAuthenticated,
    login,
    logout: () => {
      logout()
      navigate('/login')
    },
    updateUser,
  }
}
